import {AxiosError, AxiosResponse} from "axios";
import {injectable} from "inversify";

import "@/extensions/date.extensions";
import {ApiService} from "@/services/apiService";
import {IParticipantService} from "@/injection/interfaces";
import {SucceededOrNotResponse} from "@/types/responses";

@injectable()
export class ParticipantService extends ApiService implements IParticipantService {
  public async deleteParticipant(id: string): Promise<SucceededOrNotResponse> {
    const response = await this._httpClient
      .delete<string, AxiosResponse<SucceededOrNotResponse>>(`${process.env.VUE_APP_API_BASE_URL}/api/participants/${id}`)
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>;
      });
    return new SucceededOrNotResponse(response.status === 204)
  }
}